import './App.css';
import Pick5Canvas from './pick5canvas.tsx';
import { AbstractChallenge } from './abstractchallenge.tsx';
import { AbstractCanvasProps } from './abstractcanvas.tsx';
import { INGREDIENTS } from './getIngredients.ts';

interface Pick5Data {
  items: string[];
}

class Pick5 extends AbstractChallenge<Pick5Data> {
  title() {
    return "Here's a Pick 5 Challenge for you...";
  }
  
  reloadButtonText(): string {
    return "Generate Pick 5 Challenge";
  }

  canvas(props: AbstractCanvasProps<Pick5Data>) {
    return <Pick5Canvas {...props} />
  }

  getChallengeData(ingredients: INGREDIENTS): Pick5Data {
    let items = ingredients.pickRandom(10, false, false);
    return {
      items
    }
  }
}

export default Pick5;
export type {Pick5Data};
